export const DEFAULT_MIN_PLAY_DELAY_MS = 750;
export const PROGRESSIVE_PLAY_SUBMIT_DELAY_MS = 3_000;
export const DEFAULT_MIN_BID_DELAY_MS = 1_000;
export const PROGRESSIVE_DEPTH_PLAY_SCHEDULE_PREDICATE =
  'playingMaximumWorlds > playingMinimumWorlds';
